import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AuditBinderStage, AuditDocumentRequestType } from '@ata-digital/client-tax-system-api-client';
import { AuditDashboard } from '@/features/preparer/audit-dashboard/AuditDashboard';
import { auditDashboardQueryOptions } from '@/lib/query/options';

const auditDashboardSearchSchema = z
  .object({
    page: z.number().int().positive().optional().catch(undefined),
    rowsPerPage: z.number().int().positive().optional().catch(undefined),
    sortBy: z.string().optional().catch(undefined),
    sortOrder: z.enum(['asc', 'desc']).optional().catch(undefined),
    search: z.string().optional().catch(undefined),
    stages: z.array(z.nativeEnum(AuditBinderStage)).optional().catch(undefined),
    dueDateStart: z.string().optional().catch(undefined),
    dueDateEnd: z.string().optional().catch(undefined),
    officeId: z.string().optional().catch(undefined),
    scope: z.enum(['mine', 'all']).optional().catch(undefined),
    requestType: z.nativeEnum(AuditDocumentRequestType).optional().catch(undefined),
  })
  .passthrough();

export const Route = createFileRoute('/preparer/audit-dashboard')({
  loader: async ({ context: { queryClient } }) => {
    const authState = queryClient.getQueryData(['auth', 'session']) as
      | { token?: string; isAuthenticated?: boolean }
      | undefined;

    if (authState?.token) {
      queryClient
        .prefetchQuery(
          auditDashboardQueryOptions.list(
            {
              page: 1,
              limit: 25,
              sortBy: 'dueDate',
              sortOrder: 'asc',
              stages: [AuditBinderStage.New, AuditBinderStage.Open, AuditBinderStage.InReview],
            },
            authState.token
          )
        )
        .catch(() => {});
    }
  },
  component: AuditDashboard,
  validateSearch: auditDashboardSearchSchema,
});
